import { Box, Button, Link } from "@material-ui/core";
import { blueGrey, grey, red } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ClearIcon from "@material-ui/icons/Clear";
import DescriptionIcon from "@material-ui/icons/Description";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import LabelIcon from "@material-ui/icons/Label";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import PrintIcon from "@material-ui/icons/Print";
import ReplayIcon from "@material-ui/icons/Replay";
import clsx from "clsx";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ReactToPrint from "react-to-print";
import { bindActionCreators, compose } from "redux";
import DynamicIcon from "../../commons/DynamicIcon";
import consts from "../../main/consts";
import { StorageUser } from "../../main/StorageUser";
import { STATUS } from "../../main/status";
import { showMessage } from "../../state/app/appActions";
import {
	callMotoboy,
	getOrderCodigoStatus,
	handleImprimirEtiqueta,
	handshakeRappiValidate,
	retryOrder,
	updateOrderStatus,
} from "../../state/order/actions";
import { withRemoteConfig } from "../../state/remoteConfig/RemoteConfigContext";
import { remoteConfigTypes } from "../../state/remoteConfig/types";
import { isCarrierAbbiamo } from "../../utils/check-carrier";
import {
	isDeliverymanBackBlockedForSalesChannel,
	isDevolutionAllowedForSalesChannel,
	salesChannelIs99food,
	salesChannelIsAmericanas,
	salesChannelIsMarketplaceOut,
	salesChannelIsRappi,
} from "../../utils/check-sales-channel";
import DialogColeta from "./Abbiamo/DialogColeta/DialogColeta";
import DialogToken from "./Abbiamo/DialogToken/DialogToken";
import AssociadosModal from "./AssociadosModal";
import AuditoriaPedidoModal from "./AuditoriaPedidoModal";
import CancelarRecebimentoModal from "./CancelarRecebimentoModal";
import CodigoRetiradaModal from "./CodigoRetiradaModal";
import ConfirmarEstoqueModal from "./ConfirmarEstoqueModal";
import ConfirmarRecebimentoModal from "./ConfirmarRecebimentoModal";
import { EtiquetaIndisponivelModal } from "./Details/EtiquetaIndisponivelModal";
import DevolverTransportadoraModal from "./DevolverTransportadoraModal";
import { getLabelStatus } from "./helpers";
import RetornarPopup from "./helpers/RetornarPopup";
import ValidateCancelDate, { isEasterDate } from "./helpers/ValidateCancelDate";
import ValidateDevolutionDate from "./helpers/ValidateDevolutionDate";
import MotivoCancelamentoModal from "./MotivoCancelamentoModal";
import MotivoInsucessoModal from "./MotivoInsucessoModal";
import PrintReceipt from "./PrintReceipt";
import RecusarPedidoModal from "./RecusarPedidoModal";
import { isAwaitingStoreConfirmation, isAwaitingSAL } from "./ready-to-go/utils/orderStatus";

const styles = (theme) => ({
	root: {
		paddingLeft: 0,
		paddingRight: 0,
		[theme.breakpoints.down("sm")]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	button: {
		backgroundColor: blueGrey[900],
		color: "#fff",
		"&:hover": {
			backgroundColor: blueGrey[800],
		},
		[theme.breakpoints.down("sm")]: {
			paddingRight: 0,
			paddingLeft: 0,
		},
	},
	buttonCancel: {
		backgroundColor: "#fff",
		marginRight: 15,
		color: blueGrey[900],
		"&:hover": {
			backgroundColor: blueGrey[100],
		},
		[theme.breakpoints.down("sm")]: {
			paddingRight: 0,
			paddingLeft: 0,
		},
	},
	buttonRed: {
		backgroundColor: red[900],
		color: "#fff",
		"&:hover": {
			backgroundColor: red[800],
		},
		[theme.breakpoints.down("sm")]: {
			paddingRight: 0,
			paddingLeft: 0,
		},
	},
	button2: {
		[theme.breakpoints.down("sm")]: {
			paddingRight: 0,
			paddingLeft: 0,
		},
	},
	bodyClassPrint: {
		padding: theme.spacing(2),
		borderTop: "10px solid #F80032",
		color: grey[800],
		"& button": {
			display: "none",
		},
		"& .printHide": {
			display: "none",
		},
	},
	bodyClassPrintNewReceipt: {
		padding: theme.spacing(2),
		borderTop: "10px",
		color: grey[800],
		"& button": {
			display: "none",
		},
		"& .printHide": {
			display: "none",
		},
	},
	box: {
		display: "flex",
		flexDirection: "row",
		marginRight: theme.spacing(2),
		[theme.breakpoints.down("md")]: {
			width: "50%",
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			marginBottom: theme.spacing(2),
			marginRight: theme.spacing(0),
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(2),
		},
	},
	box2: {
		display: "flex",
		flexDirection: "row",
	},
	boxButtonNext: {
		marginRight: theme.spacing(0),
		[theme.breakpoints.down("md")]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	buttonAguardando: {
		backgroundColor: "transparent",
	},
	error: {
		color: `${theme.palette.primary.main} !important`,
		backgroundColor: "transparent !important",
		fontSize: "12px",
	},
	hiddenPrintContainer: {
		position: "absolute",
		left: -9999,
		top: 0,
		width: 600,
		pointerEvents: "none",
		opacity: 0,
	},
});

export const getPropBtnByStatus = (status) => {
	switch (status) {
		case STATUS.NOVO_PEDIDO:
			return { label: "picking", nextStatus: STATUS.EM_SEPARACAO };
		case STATUS.EDITADO:
		case STATUS.EM_SEPARACAO:
		case STATUS.PREVISTO:
			return { label: "ready-to-go", nextStatus: STATUS.PRONTO_PARA_SAIR };
		case STATUS.EM_EDICAO:
		case STATUS.PRONTO_PARA_SAIR:
			return { label: "shipping", nextStatus: STATUS.SAIU_PARA_ENTREGA };
		case STATUS.SAIU_PARA_ENTREGA:
			return { label: "concluded", nextStatus: STATUS.FINALIZADO };
		case STATUS.RETORNAR_PARA_ESTOQUE:
			return {
				label: "return-to-stock",
				nextStatus: STATUS.RETORNAR_PARA_ESTOQUE,
			};
		case STATUS.CANCELADO:
			return { label: "canceled", nextStatus: STATUS.CANCELADO };
		case STATUS.FINALIZADO:
			return { label: "returned", nextStatus: STATUS.DEVOLVIDO };
		default:
			return { label: "NAO_DEFINIDO", nextStatus: "NAO_DEFINIDO" };
	}
};

class OrderActions extends React.Component {
	printReceiptRef = React.createRef();

	state = {
		modalAuditoriaPedido: false,
		modalAssociado: false,
		modalConfirmaEstoque: false,
		codigo: false,
		codigoErr: false,
		codigoLoading: false,
		serverErr: null,
		openRetornarPopup: false,
		openMotivoModal: false,
		lastRetry: moment(),
		isOpenModalInsucesso: false,
		isOpenModalRecusa: false,
		isOpenModalConfirmarRecebimento: false,
		isOpenModalCancelarRetirada: false,
		isOpenModalDevolverTransportadora: false,
		setModalClosed: false,
		isOpenDialogTokenRetirada: false,
		isOpenDialogTokenDevolucao: false,
		isOpenDialogColeta: false,
		etiquetaIndisponivelObject: { isModalOpen: false, message: "" },
	};

	updateOrder = (
		numero,
		status,
		params,
		origem,
		codigoExterno,
		isInsucesso,
	) => {
		const {
			updateOrderStatus,
			setRefreshes,
			remoteConfig: { remoteConfig: remoteConfigData } = {},
		} = this.props;
		const allowedDevolutionChannels =
			remoteConfigData?.globalConfig?.isDevolutionAllowedForSalesChannel
				?.allowedSaleChannels;
		const {
			associado,
			isNome,
			motivo,
			itens,
			hasEdition,
			hasImei,
			valorEntrega,
			valorDesconto,
			recusado,
			retry,
			motivoDevolucao,
			motivoInsucesso,
			reason,
			nomeAutorizador,
			emailAutorizador,
			observacao,
		} = params;
		const nextStatus = hasEdition
			? STATUS.EDITADO
			: isInsucesso
				? STATUS.DEVOLVIDO
				: getPropBtnByStatus(status).nextStatus;

		const orderStatus = {
			numero,
			status: nextStatus,
			origem,
			codigoExterno,
		};

		if (isInsucesso && motivoInsucesso) {
			orderStatus.motivoInsucesso = motivoInsucesso;
		}
		if (associado) {
			if (isNome) orderStatus.associadoNome = associado;
			else orderStatus.associadoCpf = associado.cpf;
		}
		if (motivo) {
			orderStatus.motivo = motivo;
		}
		if (reason) {
			orderStatus.motivo = reason;
		}
		if (observacao) {
			orderStatus.observacao = observacao;
		}
		if (motivoDevolucao) {
			orderStatus.motivoDevolucao = motivoDevolucao;
		}
		if (nomeAutorizador && emailAutorizador) {
			orderStatus.nomeAutorizador = nomeAutorizador;
			orderStatus.emailAutorizador = emailAutorizador;
		}

		if ((hasEdition || hasImei) && itens && itens.length > 0) {
			const { order } = this.props;
			const newItems = order.itens.map((item, index) => {
				const codigoItem = item.codigoEAN + "_" + index;
				const selectedItem = itens.find((i) => i.codigoEAN === codigoItem);
				if (selectedItem) {
					item.quantidadeTotal = selectedItem.quantidade;
					item.valorTotal = selectedItem.quantidade * item.valorUnitario;
					if (selectedItem.imeis.length > 0) {
						item.imeis = selectedItem.imeis;
						if (selectedItem.imeis.length > selectedItem.quantidade) {
							item.imeis.splice(
								selectedItem.quantidade,
								item.imeis.length - selectedItem.quantidade,
							);
						}
					}
				}
				return item;
			});

			orderStatus.itens = newItems;
			orderStatus.valorDesconto = valorDesconto;
			orderStatus.valorEntrega = valorEntrega;
			orderStatus.valorTotal =
				newItems.reduce((ac, cv) => ac + cv.valorTotal, 0) +
				valorEntrega -
				valorDesconto;
		}

		orderStatus.editado = hasEdition !== undefined ? hasEdition : null;
		orderStatus.recusado = recusado !== undefined ? recusado : null;
		orderStatus.retry = !!retry;

		orderStatus.canalDeVendas = this.props.order.canalDeVendas;
		orderStatus.loja = this.props.order.loja;

		if (
			!motivo &&
			isDevolutionAllowedForSalesChannel(
				this.props.order.erpOrigem,
				allowedDevolutionChannels,
			) &&
			motivoDevolucao
		) {
			orderStatus.motivo = motivoDevolucao;
		}

		updateOrderStatus(orderStatus).then((res) => {
			if (res && res.payload.status === 200) {
				setRefreshes((refreshes) => refreshes + 1);
				if (this.state.isOpenDialogColeta) {
					this.setState({ isOpenDialogColeta: false });
				}
			} else if (res && res.payload && res.payload.status === 422) {
				if (res.payload.data?.message) {
					this.props.showMessage(res.payload.data.message, "error");
				}
			}
		});
	};

	isVisible = (params) => {
		const { status, origem, aguardandoEvento, pago, tipoEntrega, erro } =
			params;

		if (
			status !== undefined &&
			(status === STATUS.DEVOLVIDO || status === STATUS.CANCELADO)
		) {
			return false;
		}

		if (status === STATUS.PRONTO_PARA_SAIR && pago !== undefined && !pago) {
			return false;
		}

		if (
			status === STATUS.SAIU_PARA_ENTREGA &&
			["EXTERNA", "SAME_STATE"].includes(tipoEntrega)
		) {
			return false;
		}

		if (status === STATUS.FINALIZADO) {
			const devolutionDays = params.getDaysToDevolution({
				erpOrigem: params.erpOrigem,
				origem: params.origem,
				tipoEntrega: params.tipoEntrega,
			});
			return !ValidateDevolutionDate(params.timelines, devolutionDays);
		}

		if (
			origem !== undefined &&
			origem === "SUPERMERCADO_NOW" &&
			consts.NOW_READ_ONLY
		) {
			return false;
		}

		if (aguardandoEvento !== undefined && aguardandoEvento) {
			return false;
		}

		if (erro && erro.status) {
			return false;
		}
		return true;
	};

	action = (
		numero,
		status,
		associado,
		motivo,
		origem,
		tipoEntrega,
		notaFiscal,
		forceStatus,
		codigoExterno,
		recusado,
		retry,
		nomeAutorizador,
		emailAutorizador,
	) => {
		if (forceStatus) {
			this.updateOrder(
				numero,
				status,
				{
					associado,
					isNome: null,
					motivo,
					recusado,
					retry,
					nomeAutorizador,
					emailAutorizador,
				},
				origem,
				codigoExterno,
			);
		} else if (
			getPropBtnByStatus(status).nextStatus === STATUS.PRONTO_PARA_SAIR
		) {
			this.setState({ modalConfirmaEstoque: true, numero, status });
		} else if (
			getPropBtnByStatus(status).nextStatus === STATUS.SAIU_PARA_ENTREGA &&
			["INTERNA"].includes(tipoEntrega)
		) {
			this.setState({ modalAssociado: true, numero, status });
		} else if (
			getPropBtnByStatus(status).nextStatus === STATUS.SAIU_PARA_ENTREGA &&
			["EXTERNA", "RETIRADA", "SAME_STATE"].includes(tipoEntrega) &&
			["SHIP_FROM_STORE", "PEGUE_NA_LOJA_HOJE"].includes(origem)
		) {
			const nextStatus =
				tipoEntrega === "RETIRADA" ? STATUS.SAIU_PARA_ENTREGA : status;

			if (isCarrierAbbiamo(this.props.order.transportadora)) {
				if (tipoEntrega === "SAME_STATE" && origem === "SHIP_FROM_STORE") {
					this.setState({
						isOpenDialogColeta: true,
						numero,
						status: nextStatus,
					});
				} else {
					this.setState({
						isOpenDialogTokenRetirada: true,
						numero,
						status: nextStatus,
					});
				}
			} else {
				this.setState({ codigo: true, numero, status: nextStatus });
			}
		} else if (
			getPropBtnByStatus(status).nextStatus === STATUS.RETORNAR_PARA_ESTOQUE
		) {
			this.setState({ openRetornarPopup: true });
		} else if (getPropBtnByStatus(status).nextStatus === STATUS.DEVOLVIDO) {
			this.setState({ openRetornarPopup: true });
		} else {
			if (
				getPropBtnByStatus(status).nextStatus === STATUS.SAIU_PARA_ENTREGA &&
				!(notaFiscal && notaFiscal.chave)
			) {
				this.props.showMessage("Aviso: Pedido sem nota fiscal", "warning");
			}
			this.updateOrder(
				numero,
				status,
				{ associado, isNome: null, motivo },
				origem,
				codigoExterno,
			);
		}
	};

	handleSelectAssociado = (assoc, isNome) => {
		const { numero, status } = this.state;
		const {
			order: { origem, codigoExterno },
		} = this.props;
		this.updateOrder(
			numero,
			status,
			{ associado: assoc, isNome: isNome },
			origem,
			codigoExterno,
		);
		this.setState({ modalAssociado: false });
	};

	handleConfirmacao = (params) => {
		const {
			hasEdition,
			selectedItens,
			hasImei,
			reason,
			nomeAutorizador,
			emailAutorizador,
		} = params;
		const { numero, status } = this.state;
		const {
			order: { valorDesconto, valorEntrega, origem, codigoExterno },
		} = this.props;

		this.updateOrder(
			numero,
			status,
			{
				valorDesconto,
				valorEntrega,
				itens: selectedItens,
				hasEdition,
				hasImei,
				reason,
				nomeAutorizador,
				emailAutorizador,
			},
			origem,
			codigoExterno,
		);
		this.setState({ modalConfirmaEstoque: false });
	};

	handleCheckCodigo = (codigo) => {
		const { numero, status } = this.state;
		const {
			order: { origem, codigoExterno, erpOrigem },
		} = this.props;
		const { getOrderCodigoStatus, handshakeRappiValidate } = this.props;
		this.setState({ codigoLoading: true });
		this.setState({ codigoErr: false, serverErr: null });

		// Se for rappi chamar o handshakeValidate
		const handleValidateCode = salesChannelIsRappi(erpOrigem)
			? handshakeRappiValidate
			: getOrderCodigoStatus;
		const numeroPedido = salesChannelIsRappi(erpOrigem)
			? codigoExterno
			: numero;

		handleValidateCode(codigo, numeroPedido, (res) => {
			this.setState({ codigoLoading: false });

			if (res) {
				if (res.codigoStatus) {
					this.updateOrder(
						numero,
						status,
						{},
						origem,
						codigoExterno.split("#")[0],
					);
					this.setState({ codigo: false, codigoErr: false, serverErr: null });
				} else if (res.message) {
					this.setState({ codigoErr: true, serverErr: res.message });
				} else {
					this.setState({ codigoErr: true, serverErr: null });
				}
			} else {
				this.setState({ codigoErr: true, serverErr: "NO_RESPONSE" });
			}
		});
	};

	handleCallMotoboy = () => {
		const { callMotoboy, order } = this.props;
		callMotoboy(order.numero);
	};

	handleRetirarPedidoAbbiamo = () => {
		const { numero, status } = this.state;
		const {
			order: { origem, codigoExterno },
		} = this.props;
		this.updateOrder(numero, status, {}, origem, codigoExterno.split("#")[0]);
		this.setState({ isOpenDialogTokenRetirada: false });
	};

	checkEvento = (events, status, allowTakeoutOrderWithoutNF) => {
		const {
			order: { transportadora, erpOrigem, tipoEntrega, origem },
		} = this.props;
		const eventStatus = events.map((event) => event.status);

		const eventsPending = events.filter(
			(event) => event.status === "PENDING" && event.tipo !== "NOTA_FISCAL",
		);

		// Para pedidos marketplace out, não é necessário aguardar a emissão da nota fiscal para retirar pedido
		if (
			allowTakeoutOrderWithoutNF &&
			salesChannelIsMarketplaceOut(erpOrigem) &&
			status === STATUS.PRONTO_PARA_SAIR &&
			["EXTERNA", "RETIRADA"].includes(tipoEntrega) &&
			["SHIP_FROM_STORE", "PEGUE_NA_LOJA_HOJE"].includes(origem) &&
			eventsPending.length === 0
		) {
			const eventNFPending = events.find(
				(event) =>
					event.eventName === STATUS.PRONTO_PARA_SAIR &&
					event.tipo === "NOTA_FISCAL",
			);

			if (eventNFPending && eventNFPending.status === "PENDING") {
				return false;
			}
		}

		if (isCarrierAbbiamo(transportadora)) {
			const eventABBIAMO = events.find(
				(event) =>
					event.eventName === "PRONTO_PARA_SAIR" &&
					event.tipo === "AGUARDANDO_ABBIAMO",
			);
			if (eventABBIAMO) return false;
		}

		if (
			status !== "CANCELADO" &&
			status !== "RECUSADO" &&
			eventStatus.includes("PENDING")
		) {
			return true;
		} else return false;
	};

	eventsPending = (events) => {
		const eventos = events.map((event) => {
			if (event.status === "PENDING") return event;
			return null;
		});
		return _.compact(eventos);
	};

	eventMessage = (eventos) => {
		return eventos
			.filter(
				(e) => e.eventName !== "SAIU_PARA_ENTREGA" && e.tipo !== "ENTREGUE",
			)
			.map((e) => e.mensagem);
	};

	handleRetry = () => {
		const { retryOrder, order } = this.props;
		this.setState({ lastRetry: moment() });
		retryOrder(order.origem, order.codigoExterno);
	};

	handleRetornarPopup = (
		numero,
		status,
		associado,
		origem,
		codigoExterno,
		motivoDevolucao,
		nomeAutorizador,
		emailAutorizador,
	) => {
		this.updateOrder(
			numero,
			status,
			{
				associado,
				isNome: null,
				motivoDevolucao,
				nomeAutorizador,
				emailAutorizador,
			},
			origem,
			codigoExterno,
		);
		this.setState({ openRetornarPopup: false });
	};

	handleRetornarPopupClose = () => {
		this.setState({ openRetornarPopup: false });
	};

	handlerRecusa = () => {
		this.setState({ modalConfirmaEstoque: false });
		this.setState({ openMotivoModal: true });
	};

	handleCloseMotivoModal = () => {
		this.setState({ openMotivoModal: false });
	};

	handleModalInsucesso = () => {
		const {
			order: { transportadora },
		} = this.props;

		if (isCarrierAbbiamo(transportadora)) {
			this.setState({
				isOpenDialogTokenDevolucao: !this.state.isOpenDialogTokenDevolucao,
			});
		} else {
			this.setState({ isOpenModalInsucesso: !this.state.isOpenModalInsucesso });
		}
	};

	submitOrderInsucesso = (
		motivoInsucesso,
		motivoDevolucao,
		nomeAutorizador,
		emailAutorizador,
	) => {
		const {
			order: {
				numero,
				status,
				origem,
				codigoExterno,
				canalDeVendas,
				transportadora,
			},
		} = this.props;

		const params = salesChannelIsAmericanas(canalDeVendas)
			? {
					motivoInsucesso,
					motivoDevolucao,
					nomeAutorizador,
					emailAutorizador,
				}
			: {
					motivo: motivoInsucesso.nome,
					observacao: motivoDevolucao !== "" ? motivoDevolucao : null,
				};

		this.updateOrder(numero, status, params, origem, codigoExterno, true);
		this.handleModalInsucesso();
	};

	handleModalRecusa = () => {
		this.setState({ isOpenModalRecusa: !this.state.isOpenModalRecusa });
	};

	handleModalConfirmarRecebimento = () => {
		this.setState({
			isOpenModalConfirmarRecebimento:
				!this.state.isOpenModalConfirmarRecebimento,
		});
	};

	handleModalCancelarRetirada = () => {
		this.setState({
			isOpenModalCancelarRetirada: !this.state.isOpenModalCancelarRetirada,
		});
	};

	handleModalDevolverTransportadora = () => {
		this.setState({
			isOpenModalDevolverTransportadora:
				!this.state.isOpenModalDevolverTransportadora,
		});
	};

	handleCloseDialogTokenRetirada = (
		eventAbbiamoStatus,
		setRetirarPedidoAbbiamo,
	) => {
		setRetirarPedidoAbbiamo({
			shouldShowAlerta: eventAbbiamoStatus === "DONE" ? true : false,
			handler:
				eventAbbiamoStatus === "DONE"
					? this.handleRetirarPedidoAbbiamo
					: undefined,
		});
		this.setState({ isOpenDialogTokenRetirada: false });
	};

	checkIfShowCancelButton = (
		storageUser,
		status,
		validateDays,
		erpOrigem,
		origem,
		date,
	) => {
		const validateDaysToCancel =
			origem === "PEGUE_NA_LOJA_HOJE" && isEasterDate()
				? dayjs(date).add(1, "days").isBefore(dayjs())
				: validateDays;

		if (storageUser.allowedByPermission("ADMIN_INLINE_CANCEL")) {
			return status === STATUS.PRONTO_PARA_SAIR;
		}

		return (
			(storageUser.allowedByPermission("INLINE_CANCEL") ||
				storageUser.allowedByPermission("INLINE_CANCEL_CONFIRM")) &&
			status === STATUS.PRONTO_PARA_SAIR &&
			validateDaysToCancel &&
			(salesChannelIsAmericanas(erpOrigem)
				? origem !== "SHIP_FROM_STORE"
				: true) &&
			origem !== "PEGUE_NA_LOJA"
		);
	};

	checkErpOriginToGetTokenInsucesso = (erpOrigem) => {
		return ["ifood", "99food", "rappi"].includes(erpOrigem?.toLowerCase());
	};

	checkIfNewReceiptIsEnabled = (erpOrigem, newReceipt) => {
		return newReceipt && salesChannelIsMarketplaceOut(erpOrigem);
	};

	handlePrintEtiquetaTransporte = async () => {
		const {
			order: { numero },
		} = this.props;
		const res = await this.props.handleUpdateEventImprimirEtiqueta(numero);
		if (res && res.status === "SHOULD_OPEN_MODAL") {
			this.setState({
				etiquetaIndisponivelObject: { isModalOpen: true, message: res.message },
			});
			return;
		}
		if (res && res.status === 200) {
			const url = window.URL.createObjectURL(
				new Blob([res.data], { type: "application/pdf" }),
			);
			const link = document.createElement("a");
			link.href = url;
			link.download = `etiqueta-${numero}.pdf`;
			link.click();
			window.URL.revokeObjectURL(url);
		}
	};

	render() {
		const {
			classes,
			order: {
				numero,
				status,
				itens,
				preVenda,
				associado,
				origem,
				entregas,
				tipoEntrega,
				notaFiscal,
				notaFiscalDevolucao,
				events,
				erro,
				codigoExterno,
				statusForIntegration,
				timelines,
				deliveryToken,
				dhEntregaEstimada,
				dataInclusao,
				dataAlteracao,
				erpOrigem,
				canalDeVendas,
				handshakeRappi
			},
			match,
			printRef,
			ignoreReason,
			aceitarDevolucao,
			auth,
			setRetirarPedidoAbbiamo,
			remoteConfig: {
				getToggleFeature,
				getGlobalConfig,
				getDaysToDevolution,
				remoteConfig: remoteConfigData,
			} = {},
		} = this.props;

		const newPrintReceipt = getToggleFeature
			? getToggleFeature("order", "details", "newReceipt")
			: false;
		const allowTakeoutOrderWithoutNF = getToggleFeature
			? getToggleFeature("order", "details", "allowTakeoutOrderWithoutNF")
			: false;
		const nfUrlReceitaFederal = getGlobalConfig
			? getGlobalConfig(
					remoteConfigTypes.GLOBAL_CONFIG.NOTA_FISCAL_URL_RECEITA_FEDERAL,
				) || consts.NOTA_FISCAL_URL_RECEITA_FEDERAL
			: consts.NOTA_FISCAL_URL_RECEITA_FEDERAL;
		const allowedDevolutionChannels = remoteConfigData?.globalConfig
			?.isDevolutionAllowedForSalesChannel?.allowedSaleChannels ?? [
			"magalu",
			"shopee",
			"rappi",
			"ifood",
		];
		const blockedDeliverymanChannels = remoteConfigData?.globalConfig
			?.isDeliverymanBackBlockedForSalesChannel?.allowedSaleChannels ?? [
			"99food",
			"rappi",
		];

		const eventABBIAMO = events?.find(
			(event) =>
				event.eventName === "PRONTO_PARA_SAIR" &&
				event.tipo === "AGUARDANDO_ABBIAMO",
		);
		const eventDevolutionABBIAMO = events?.find(
			(event) =>
				event.eventName === "SAIU_PARA_ENTREGA" &&
				event.tipo === "AGUARDANDO_DEVOLUCAO_ABBIAMO",
		);

		const notaFiscalEvent = events?.find(
			(event) =>
				event.eventName === "PRONTO_PARA_SAIR" &&
				event.tipo === "IMPRIMIR_NOTA_FISCAL",
		);
		const showEtiquetaTransporte =
			tipoEntrega === "SAME_STATE" &&
			notaFiscalEvent?.status === "DONE" &&
			[
				"PRONTO_PARA_SAIR",
				"SAIU_PARA_ENTREGA",
				"DEVOLVIDO",
				"FINALIZADO",
			].includes(status);

		const entrega = entregas && entregas[entregas.length - 1];
		const codigoEntrega = entrega && entrega.codigo;
		const aguardandoEvento =
			(events &&
				this.checkEvento(events, status, allowTakeoutOrderWithoutNF)) ||
			false;

		const isFuturePreVenda =
			status === STATUS.EM_SEPARACAO &&
			preVenda === true &&
			moment.utc(dhEntregaEstimada).isAfter(moment.utc(), "day");

		const isAwaitingStore =
			isAwaitingStoreConfirmation(this.props.order) ||
			isAwaitingSAL(this.props.order);

		const filteredItens =
			(itens && itens.filter((item) => item.quantidade > 0)) || [];
		const lock =
			events && events.length === 1 && events[0].eventName === "CANCELADO";
		const validateDays = ValidateCancelDate(dhEntregaEstimada || dataInclusao);
		const validateDaysCeC = ValidateCancelDate(null, true, dataAlteracao);
		const imeis = [];

		for (let i = 0; i < filteredItens.length; i++) {
			const item = filteredItens[i];
			if (item.quantidadeImeis > 0) {
				imeis[i] = [];
				for (let j = 0; j < item.quantidade; j++) {
					imeis[i][j] = [];
					for (let k = 0; k < item.quantidadeImeis; k++) {
						const val = item.imeis[j] ? item.imeis[j][k] : "";
						imeis[i][j][k] = val;
					}
				}
			}
		}

		let retryEnabled = true;
		if (erro && erro.date) {
			/* const timeOfError = moment(erro.date); */
			const now = moment();
			/* const timeSinceError = now.diff(timeOfError, 'minutes', true); */
			const timeSinceLastRetry = now.diff(
				this.state.lastRetry,
				"minutes",
				true,
			);
			if (timeSinceLastRetry > consts.RETRY_DELAY_MINUTES) {
				retryEnabled = false;
			}
		}

		const storageUser = new StorageUser();

		return (
			<Box
				flexGrow={1}
				display="flex"
				p={0}
				flexWrap="wrap"
				className={classes.root}
			>
				{origem !== "PEGUE_NA_LOJA" && (
					<Box className={classes.box}>
						<ReactToPrint
							trigger={() => (
								<Button
									fullWidth
									size="large"
									variant="outlined"
									disableElevation
									color="default"
									className={classes.iconButton}
									startIcon={<PrintIcon />}
								>
									IMPRIMIR
								</Button>
							)}
							content={() =>
								this.checkIfNewReceiptIsEnabled(erpOrigem, newPrintReceipt)
									? this.printReceiptRef.current
									: printRef.current
							}
							bodyClass={
								this.checkIfNewReceiptIsEnabled(erpOrigem, newPrintReceipt)
									? classes.bodyClassPrintNewReceipt
									: classes.bodyClassPrint
							}
						/>
					</Box>
				)}

				{this.checkIfNewReceiptIsEnabled(erpOrigem, newPrintReceipt) && (
					<Box className={classes.hiddenPrintContainer} aria-hidden="true">
						<div ref={this.printReceiptRef}>
							<PrintReceipt
								order={this.props.order}
								nfUrlReceitaFederal={nfUrlReceitaFederal}
							/>
						</div>
					</Box>
				)}

				{storageUser.allowedByPermission("AUDITORIA") &&
					events &&
					events.length > 0 && (
						<Box className={classes.box}>
							<Button
								fullWidth
								size="large"
								variant="outlined"
								disableElevation
								color="default"
								className={classes.iconButton}
								startIcon={<DescriptionIcon />}
								onClick={() => this.setState({ modalAuditoriaPedido: true })}
							>
								AUDITORIA
							</Button>
						</Box>
					)}

				{this.checkIfShowCancelButton(
					storageUser,
					status,
					validateDays,
					erpOrigem,
					origem,
					dhEntregaEstimada || dataInclusao,
				) && (
					<Box className={classes.box}>
						<Button
							disabled={lock}
							variant="contained"
							color="primary"
							size="small"
							startIcon={<ClearIcon />}
							onClick={this.handlerRecusa}
						>
							Cancelar
						</Button>
					</Box>
				)}

				{storageUser.allowedByPermission("EDITAR_PEDIDO") &&
					status === STATUS.PRONTO_PARA_SAIR &&
					validateDaysCeC &&
					origem === "PEGUE_NA_LOJA" && (
						<Box className={classes.box}>
							<Button
								disabled={lock}
								variant="contained"
								color="primary"
								size="small"
								startIcon={<ClearIcon />}
								onClick={this.handlerRecusa}
							>
								Solicitar coleta
							</Button>
						</Box>
					)}

				{(storageUser.allowedByPermission("INLINE_CANCEL") ||
					storageUser.allowedByPermission("INLINE_CANCEL_CONFIRM")) &&
					status === STATUS.SAIU_PARA_ENTREGA &&
					["EXTERNA", "SAME_STATE"].includes(tipoEntrega) &&
					!isDeliverymanBackBlockedForSalesChannel(
						erpOrigem,
						blockedDeliverymanChannels,
					) && (
						<Box className={classes.box}>
							<Button
								variant="contained"
								color="primary"
								size="small"
								startIcon={<MotorcycleIcon />}
								onClick={this.handleModalInsucesso}
							>
								Entregador voltou
							</Button>
						</Box>
					)}

				{status !== STATUS.FINALIZADO && <Box flexGrow={1}></Box>}

				{storageUser.allowedByPermission("EDITAR_PEDIDO") &&
					this.isVisible({ aguardandoEvento: aguardandoEvento }) &&
					status === STATUS.PRONTO_PARA_SAIR &&
					tipoEntrega === "INTERNA" && (
						<Box className={classes.box}>
							<Button
								fullWidth
								size="large"
								variant="outlined"
								color="default"
								disableElevation
								className={classes.button2}
								startIcon={<MotorcycleIcon />}
								onClick={this.handleCallMotoboy}
							>
								Chamar motoboy
							</Button>
						</Box>
					)}

				{showEtiquetaTransporte && (
					<Box className={classes.box}>
						<Button
							fullWidth
							size="large"
							variant="outlined"
							color="default"
							disableElevation
							className={classes.button2}
							startIcon={<LabelIcon />}
							onClick={this.handlePrintEtiquetaTransporte}
						>
							Etiqueta de transporte
						</Button>
					</Box>
				)}

				{notaFiscal &&
					notaFiscal.chave &&
					(!salesChannelIsMarketplaceOut(erpOrigem) ||
						[
							STATUS.FINALIZADO,
							STATUS.SAIU_PARA_ENTREGA,
							STATUS.DEVOLVIDO,
							STATUS.PRONTO_PARA_SAIR,
							STATUS.CANCELADO,
						].includes(status)) && (
						<Box className={classes.box}>
							<Button
								fullWidth
								size="large"
								variant="outlined"
								color="default"
								disableElevation
								className={classes.button2}
								startIcon={<DescriptionIcon />}
							>
								<Link
									href={consts.NOTA_FISCAL_URL + notaFiscal.chave}
									target="_blank"
									color="inherit"
									underline="none"
								>
									Nota Fiscal
								</Link>
							</Button>
						</Box>
					)}
				{notaFiscalDevolucao && (
					<Box className={classes.box}>
						<Button
							fullWidth
							size="large"
							variant="outlined"
							color="default"
							disableElevation
							className={classes.button2}
							startIcon={<DescriptionIcon />}
						>
							<Link
								href={consts.NOTA_FISCAL_URL + notaFiscalDevolucao.chave}
								target="_blank"
								color="inherit"
								underline="none"
							>
								Nota Fiscal de Devolução
							</Link>
						</Button>
					</Box>
				)}
				{erro && erro.status && (
					<Box className={classes.box}>
						<Button
							fullWidth
							size="large"
							variant="contained"
							disableElevation
							startIcon={<ErrorOutlineIcon />}
							className={classes.error}
							disabled
						>
							Processando sua solicitação...
						</Button>
					</Box>
				)}

				{(storageUser.allowedByPermission("INLINE_CANCEL") ||
					storageUser.allowedByPermission("INLINE_CANCEL_CONFIRM")) &&
					origem === "PEGUE_NA_LOJA" &&
					status === STATUS.PREVISTO &&
					!aguardandoEvento && (
						<React.Fragment>
							<Box className={clsx(classes.box2)}>
								<Button
									fullWidth
									size="large"
									variant="outlined"
									/* disableElevation */
									className={classes.buttonCancel}
									onClick={this.handleModalRecusa}
								>
									Recusar recebimento
								</Button>
							</Box>

							<Box className={clsx(classes.box2)}>
								{storageUser.allowedByPermission("EDITAR_PEDIDO") && (
									<Button
										fullWidth
										size="large"
										variant="contained"
										disableElevation
										className={classes.button}
										onClick={this.handleModalConfirmarRecebimento}
										setRefreshes={this.props.setRefreshes}
									>
										Confirmar recebimento
									</Button>
								)}
							</Box>
						</React.Fragment>
					)}

				{origem === "PEGUE_NA_LOJA" &&
					status === STATUS.PRONTO_PARA_SAIR &&
					!aguardandoEvento && (
						<>
							{" "}
							{(storageUser.allowedByPermission("INLINE_CANCEL") ||
								storageUser.allowedByPermission("INLINE_CANCEL_CONFIRM")) && (
								<Box className={clsx(classes.box2)}>
									<Button
										fullWidth
										size="large"
										variant="outlined"
										/* disableElevation */
										className={classes.buttonCancel}
										onClick={this.handleModalCancelarRetirada}
									>
										CANCELAR RETIRADA
									</Button>
								</Box>
							)}
							{storageUser.allowedByPermission("EDITAR_PEDIDO") && (
								<Box className={clsx(classes.box2)}>
									<Button
										fullWidth
										size="large"
										variant="contained"
										disableElevation
										className={classes.button}
										onClick={() =>
											this.setState({ codigo: true, numero, status })
										}
									>
										RETIRAR PEDIDO
									</Button>
								</Box>
							)}
						</>
					)}

				{(storageUser.allowedByPermission("INLINE_CANCEL") ||
					storageUser.allowedByPermission("INLINE_CANCEL_CONFIRM")) &&
					origem === "PEGUE_NA_LOJA" &&
					status === STATUS.RETORNAR_PARA_ESTOQUE &&
					!aguardandoEvento && (
						<Box className={clsx(classes.box2)}>
							<Button
								fullWidth
								size="large"
								variant="outlined"
								className={classes.button}
								onClick={this.handleModalDevolverTransportadora}
							>
								DEVOLVER PARA A TRANSPORTADORA
							</Button>
						</Box>
					)}

				<Box className={clsx(classes.box, classes.boxButtonNext)}>
					{storageUser.allowedByPermission("EDITAR_PEDIDO") &&
						erro &&
						erro.status &&
						statusForIntegration && (
							<Button
								fullWidth
								size="large"
								variant="contained"
								disableElevation
								startIcon={<ReplayIcon />}
								color="primary"
								onClick={
									status === STATUS.EM_SEPARACAO
										? () => {
												this.action(
													numero,
													status,
													associado,
													null,
													origem,
													tipoEntrega,
													notaFiscal,
													null,
													codigoExterno,
												);
											}
										: () => this.handleRetry()
								}
								disabled={retryEnabled}
								className={classes.buttonRetentativa}
							>
								{!retryEnabled ? "Tentar Novamente" : "Processando..."}
							</Button>
						)}

					{status === STATUS.FINALIZADO &&
					salesChannelIsMarketplaceOut(erpOrigem) &&
					!isDevolutionAllowedForSalesChannel(
						erpOrigem,
						allowedDevolutionChannels,
					) ? (
						<></>
					) : (
						storageUser.allowedByPermission("EDITAR_PEDIDO") &&
						this.isVisible({
							status,
							origem,
							aguardandoEvento,
							tipoEntrega,
							erro,
							timelines,
							erpOrigem,
							getDaysToDevolution,
						}) &&
						origem !== "PEGUE_NA_LOJA" && (
							<Button
								fullWidth
								size="large"
								variant="contained"
								disableElevation
								disabled={
									(status === STATUS.FINALIZADO && !aceitarDevolucao) ||
									isFuturePreVenda ||
									isAwaitingStore
								}
								className={
									status === STATUS.FINALIZADO
										? classes.buttonRed
										: classes.button
								}
								startIcon={<ArrowForwardIcon />}
								endIcon={
									status !== STATUS.FINALIZADO &&
									(status === STATUS.PRONTO_PARA_SAIR &&
									["EXTERNA", "RETIRADA", "SAME_STATE"].includes(tipoEntrega) &&
									["SHIP_FROM_STORE", "PEGUE_NA_LOJA_HOJE"].includes(origem) ? (
										<AllInboxIcon />
									) : (
										<DynamicIcon icon={getPropBtnByStatus(status).label} />
									))
								}
								onClick={() => {
									this.action(
										numero,
										status,
										associado,
										null,
										origem,
										tipoEntrega,
										notaFiscal,
										null,
										codigoExterno,
									);
								}}
							>
								{status === STATUS.PRONTO_PARA_SAIR &&
								["EXTERNA", "RETIRADA", "SAME_STATE"].includes(tipoEntrega) &&
								["SHIP_FROM_STORE", "PEGUE_NA_LOJA_HOJE"].includes(origem)
									? "Retirar Pedido"
									: getLabelStatus[getPropBtnByStatus(status).label] || ""}
							</Button>
						)
					)}
				</Box>

				<AuditoriaPedidoModal
					open={this.state.modalAuditoriaPedido}
					handleClose={() => this.setState({ modalAuditoriaPedido: false })}
					data={this.props.order}
					/* handleSelect={this.handleSelectAssociado} */
				/>

				{status === STATUS.PRONTO_PARA_SAIR && tipoEntrega === "INTERNA" && (
					<AssociadosModal
						open={this.state.modalAssociado}
						handleClose={() => this.setState({ modalAssociado: false })}
						handleSelect={this.handleSelectAssociado}
					/>
				)}

				{status === STATUS.EM_SEPARACAO && (
					<ConfirmarEstoqueModal
						open={this.state.modalConfirmaEstoque}
						handleClose={() => this.setState({ modalConfirmaEstoque: false })}
						order={this.props.order}
						itens={filteredItens}
						imeis={imeis}
						handleConfirmacao={this.handleConfirmacao}
						action={this.action}
						origem={this.origem}
						orderNumber={this.numero}
						status={this.status}
						handlerRecusa={this.handlerRecusa}
						codigoExterno={codigoExterno}
					/>
				)}

				{this.state.codigo && (
					<CodigoRetiradaModal
						tipoEntrega={tipoEntrega}
						codigoEntrega={codigoEntrega}
						codigoExterno={codigoExterno}
						erpOrigem={erpOrigem}
						canalDeVendas={canalDeVendas}
						notaFiscal={notaFiscal}
						idPedido={this.props?.order?.codigoExterno}
						open={this.state.codigo}
						err={this.state.codigoErr}
						serverErr={this.state.serverErr}
						loading={this.state.codigoLoading}
						handleClose={() =>
							this.setState({
								codigo: false,
								codigoErr: false,
								serverErr: null,
							})
						}
						handleSelect={this.handleCheckCodigo}
						printRef={
							this.checkIfNewReceiptIsEnabled(erpOrigem, newPrintReceipt)
								? this.printReceiptRef.current
								: printRef.current
						}
						newPrintReceipt={this.checkIfNewReceiptIsEnabled(
							erpOrigem,
							newPrintReceipt,
						)}
						handshakeRappi={handshakeRappi}
					/>
				)}

				<RetornarPopup
					numero={numero}
					status={status}
					associado={associado}
					itens={itens}
					open={this.state.openRetornarPopup}
					handleClose={this.handleRetornarPopupClose}
					handleConfirm={this.handleRetornarPopup}
					origem={origem}
					codigoExterno={codigoExterno}
					auth={auth}
				/>
				<MotivoCancelamentoModal
					origem={origem}
					orderNumber={numero}
					status={status}
					action={this.action}
					retry={!retryEnabled}
					openModal={this.state.openMotivoModal}
					handleClose={this.handleCloseMotivoModal}
					codigoExterno={codigoExterno}
					ignoreReason={ignoreReason}
				/>
				<MotivoInsucessoModal
					openModal={this.state.isOpenModalInsucesso}
					handleClose={this.handleModalInsucesso}
					submit={this.submitOrderInsucesso}
					tokenInsucesso={deliveryToken ? deliveryToken.tokenInsucesso : ""}
					getTokenInsucesso={this.checkErpOriginToGetTokenInsucesso(erpOrigem)}
					orderId={match.params.orderId}
				/>
				<RecusarPedidoModal
					open={this.state.isOpenModalRecusa}
					handleClose={this.handleModalRecusa}
					codigoExterno={codigoExterno}
					origem={origem}
					setRefreshes={this.props.setRefreshes}
				/>
				<ConfirmarRecebimentoModal
					open={this.state.isOpenModalConfirmarRecebimento}
					handleClose={this.handleModalConfirmarRecebimento}
					numero={numero}
					status={status}
					origem={origem}
					codigoExterno={codigoExterno}
					setRefreshes={this.props.setRefreshes}
				/>
				<CancelarRecebimentoModal
					open={this.state.isOpenModalCancelarRetirada}
					handleClose={this.handleModalCancelarRetirada}
					numero={numero}
					status={status}
					origem={origem}
					codigoExterno={codigoExterno}
					setRefreshes={this.props.setRefreshes}
				/>
				<DevolverTransportadoraModal
					open={this.state.isOpenModalDevolverTransportadora}
					origem={origem}
					codigoExterno={codigoExterno}
					handleClose={this.handleModalDevolverTransportadora}
					setRefreshes={this.props.setRefreshes}
				/>

				{this.state.isOpenDialogTokenRetirada && (
					<DialogToken
						mode="retirada"
						open={this.state.isOpenDialogTokenRetirada}
						handleClose={() =>
							this.handleCloseDialogTokenRetirada(
								eventABBIAMO?.status,
								setRetirarPedidoAbbiamo,
							)
						}
						handleSubmit={this.handleRetirarPedidoAbbiamo}
						tokenProp={deliveryToken ? deliveryToken.tokenRetirada : ""}
						orderId={match.params.orderId}
						abbiamoStatus={eventABBIAMO?.status}
					/>
				)}

				{this.state.isOpenDialogTokenDevolucao && (
					<DialogToken
						mode="devolucao"
						open={this.state.isOpenDialogTokenDevolucao}
						handleClose={() =>
							this.setState({ isOpenDialogTokenDevolucao: false })
						}
						handleSubmit={this.submitOrderInsucesso}
						tokenProp={deliveryToken ? deliveryToken.tokenInsucesso : ""}
						orderId={match.params.orderId}
						abbiamoStatus={eventDevolutionABBIAMO?.status}
					/>
				)}

				{this.state.isOpenDialogColeta && (
					<DialogColeta
						open={this.state.isOpenDialogColeta}
						handleClose={() => this.setState({ isOpenDialogColeta: false })}
						orderId={match.params.orderId}
						abbiamoStatus={eventABBIAMO?.status}
						handleSubmit={this.handleRetirarPedidoAbbiamo}
					/>
				)}

				<EtiquetaIndisponivelModal
					open={this.state.etiquetaIndisponivelObject.isModalOpen}
					handleClose={() =>
						this.setState({ etiquetaIndisponivelObject: { isModalOpen: false, message: "" } })
					}
					message={this.state.etiquetaIndisponivelObject.message}
				/>
			</Box>
		);
	}
}

const mapStateToProps = (state) => {
	return { orders: state.orders, auth: state.auth };
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateOrderStatus,
			getOrderCodigoStatus,
			handshakeRappiValidate,
			callMotoboy,
			retryOrder,
			handleUpdateEventImprimirEtiqueta: handleImprimirEtiqueta,
			showMessage,
		},
		dispatch,
	);

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
	withRemoteConfig,
)(OrderActions);
